<template>
  <b-dropdown
    class="d-block"
    variant="outline-default"
    menu-class="menu-shadow scrollable text-medium"
    boundary="window"
    :toggle-class="
      'rounded-pill kr-selector-field text-truncate text-medium ' + (isErrored ? 'errored' : '')
    "
    :lazy="true"
    no-caret
  >
    <template slot="button-content">
      <div class="d-flex align-items-center">
        <i class="kr-icon-greyed flex-shrink-0 mt-1"></i>
        <span
          class="kr-title text-truncate text-prime text-small-1"
          :class="{ 'text-secondary': !selected }"
          v-no-capture
          >{{ krTitle ? krTitle : 'Choose a KR' }}</span
        >
      </div>
    </template>
    <b-dropdown-item
      :active="kr.id === selected"
      v-for="kr in krs"
      :key="kr.id"
      @click="$emit('change', kr)"
    >
      <div class="d-flex align-items-center">
        <i class="kr-icon-greyed flex-shrink-0"></i>
        <div class="dropdown-kr-title text-truncate ml-2" :title="kr.title" v-no-capture>
          {{ kr.title }}
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'

/**
 * This shows a dropdown having list of KRs from which user can select
 *
 * @emits
 * - change: kr object is is passed as payload
 */
export default {
  name: 'KrSelector',
  props: ['krs', 'selected', 'isErrored'], // TODO: remove isErrored prop
  computed: {
    krTitle() {
      const kr = this.krs.find(kr => kr.id === this.selected)
      return kr?.title
    }
  },
  components: {
    BDropdown,
    BDropdownItem
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

/deep/ .kr-selector-field {
  overflow: hidden;
  border-radius: 15px;
  padding: 2px 12px;
  max-width: 100%;
  min-width: 150px;

  &:hover,
  &:focus,
  &[aria-expanded='true'] {
    box-shadow: none;
    background-color: $quinary;
  }

  &.errored {
    border-color: $error;
  }
}

.kr-title {
  margin-left: 6px;
}

.dropdown-kr-title {
  max-width: 320px;
}

.kr-icon-greyed {
  @include dimension(8px, 12px);
}
</style>
